import { configureStore } from "@reduxjs/toolkit";
import serviceReducer from "../features/services/serviceSlice"

export const store = configureStore({
    reducer:{
        service: serviceReducer
    }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;